import { ICachingSpecification } from "./cache/caching-specification.interface";

export class Response {

	public content: any;
	public cachingSpecification: ICachingSpecification | null;

	constructor(content: any, cachingSpecification: ICachingSpecification | null) {

		this.content = content;
		this.cachingSpecification = cachingSpecification;
	}
}
